import { useRouter as useNavigation } from 'next/navigation';
import type { ReactNode } from 'react';
import { defineMessages } from 'react-intl';

import type { GraphModalInstance } from '../../../components/GraphModal/GraphModal';
import { GraphModal } from '../../../components/GraphModal/GraphModal';
import { useConnectedRouter } from '../../../hooks/useConnectedRouter';
import { deleteTopic } from '../../api/topic';
import { RemoveContent } from '../../Remove/RemoveContent';
import { useRemoveTopicWrapper } from '../../thread-utils';

const messages = defineMessages({
  title: { defaultMessage: 'Topic deletion', id: 'VkN1nv' },
  guide: { defaultMessage: 'Are you sure you want to delete your topic?', id: 'Q/ylWK' },
  cancel: { defaultMessage: 'keep the topic', id: 'KtD/wX' },
  remove: { defaultMessage: 'delete', id: 'sznaQh' },
  confirmationLabel: { defaultMessage: 'the topic has been deleted', id: 'CQA57B' },
  failureLabel: { defaultMessage: 'impossible to delete the topic', id: '35lchP' },
});

export type TopicRemoverProps = {
  topicId: string;
  content: string;
  children?: ReactNode;
};

/**
 *
 * @param topicId
 * @param content
 * @param children
 * @constructor
 */
export const TopicRemover = ({ topicId, content, children }: TopicRemoverProps) => {
  const remove = useRemoveTopicWrapper(deleteTopic, topicId);
  const { replace } = useConnectedRouter();
  const { refresh } = useNavigation();

  return (
    <GraphModal
      maxWidth={400}
      lazyContent={(tip: GraphModalInstance) => (
        <RemoveContent
          messages={messages}
          cancel={() => tip?.hide()}
          remove={async () => {
            await remove();
            tip?.hide();
            await replace('/');
            refresh();
          }}
          content={content}
        />
      )}
      showPageOverlay
      forceModal
    >
      {children}
    </GraphModal>
  );
};
